import Page from 'lib/page'
import FastClick from 'fastclick'
import {SideMenu} from './navigation'
import CMTForm from 'plugins/form'
import DatePickerForm from './forms/date-picker-form'

// Set up FastClick
document.addEventListener('DOMContentLoaded', function () {
  FastClick.attach(document.body)
})

// Set up side menu
let sideMenu = null
let sidemenuContainer = document.getElementById('side-panel')
if (sidemenuContainer) {
  sideMenu = new SideMenu(
    sidemenuContainer,
    document.getElementById('page')
  )
  const toggleButtons = document.querySelectorAll('a[href="#side-panel"]')
  for (let i = 0; i < toggleButtons.length; i++) {
    sideMenu.addToggler(toggleButtons[i])
  }
}

// Set up date picker forms
window.addEventListener('cmt-form-initialized', function (event) {
  if (event.detail.form.element.classList.contains('cmt-date-picker-form')) {
    event.detail.form.datePicker = new DatePickerForm(event.detail.form)
  }
})

// Set up forms
const forms = []
const formElements = document.querySelectorAll('form.cmt-form')
for (let i = 0; i < formElements.length; i++) {
  let formElement = formElements[i]
  forms.push(new CMTForm(formElement))
}

// Set up page
const page = new Page()

// Export
export {sideMenu, page}



// WEBPACK FOOTER //
// ./src/js/instance.js